import { render, staticRenderFns } from "./VFairHeader.vue?vue&type=template&id=5fa7075a&scoped=true"
import script from "./VFairHeader.vue?vue&type=script&lang=ts"
export * from "./VFairHeader.vue?vue&type=script&lang=ts"
import style0 from "./VFairHeader.vue?vue&type=style&index=0&id=5fa7075a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa7075a",
  null
  
)

export default component.exports